import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { AccountClosureReason } from '__generated__/GQL';

import { AccountClosureFormValues } from '../../../../types';

const useRemoveUniqueReasonsIfNeeded = () => {
  const { getValues, setValue } = useFormContext();

  useEffect(() => {
    const { reasons } = getValues() as AccountClosureFormValues;

    const initialTotalReasons = reasons.size;

    /**
     * "StopActivity" reason cannot be selected with other reasons.
     * "StopActivity" is a special reason: if the user selected it, he's not asked
     * to anwser any other questions and is directly redirected to the last screens
     * before closing its account definitely.
     */
    if (reasons.has(AccountClosureReason.StopActivity)) {
      reasons.delete(AccountClosureReason.StopActivity);
    }

    /**
     * "Other" reason cannot be selected with other reasons.
     * If the user went to the "Other" form step on `/statisfaction/other` URL,
     * then goes back to a "Satisfaction" screen,
     * we remove the `Other` reason from selected reasons.
     */
    if (reasons.has(AccountClosureReason.Other)) {
      reasons.delete(AccountClosureReason.Other);
    }

    if (reasons.size !== initialTotalReasons) {
      setValue('reasons', reasons);
    }
  }, [getValues, setValue]);
};

export default useRemoveUniqueReasonsIfNeeded;
